import React from 'react';
import styled from "styled-components";

const SGrammarPerifrasis = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarPerifrasis = () => {
  return (
    <SGrammarPerifrasis>
<h5>Perífrasis verbales - Wyrażenia czasownikowe</h5>

<p>
<i>Perífrasis verbales</i> to wyrażenia złożone z czasownika i bezokolicznika, imiesłowu biernego lub czynnego. Oba te czasowniki tworzą jedną całość znaczeniową, w związku z tym nie należy ich tłumaczyć oddzielnie. Najczęściej spotykane <i>perífrasis</i> to:
</p>

<h6>Łączące się z bezokolicznikiem:</h6>
<b>tener que</b> - musieć<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Tienes que estudiar mucho</i> - Musisz się dużo uczyć.<br/>
<b>hay que</b> - należy, trzeba<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Hay que ser sincero</i> - Trzeba być szczerym.<br/>
<b>ir a</b> - zamierzać coś zrobić<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Manana no voy a estar en casa</i> - Jutro nie będzie mnie w domu.<br/>
<b>ponerse a</b> - zacząć<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Cuando le dijo eso, ella se puso a llorar</i> - Kiedy jej to powiedział, zaczęła płakać.<br/>
<b>dejar de</b> - przestać<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Juan ha dejado de fumar</i> - Juan przestał palić.<br/>
<b>volver a</b> - zrobić coś ponownie<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>No ha vuelto a llamar</i> - Nie zadzwoniła ponownie.<br/>

<h6>Łączące się z imiesłowem czynnym:</h6>
<b>estar</b> - być w trakcie wykonywania jakiejś czynności<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>No me molestes, estoy trabajando</i> - Nie przeszkadzaj mi, pracuję.<br/>
<b>llevar</b> - robić coś od jakiegoś czasu<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Llevan saliendo juntos cuatro meses</i> - Od czterech miesięcy chodzą ze sobą.<br/>
<b>seguir</b> - robić coś w dalszym ciągu<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Sigo trabajando en la misma empresa</i> - Dalej pracuję w tej samej firmie.
    </SGrammarPerifrasis>
  )
};

export default GrammarPerifrasis;